import Hero from './components/Hero';
import Features from './components/Features';
import Screenshots from './components/Screenshots';
import Footer from './components/Footer';

/**
 * Public marketing page. Composes the four hero/feature/showcase/footer
 * sections — kept as its own component so `App.tsx` can route between this
 * and the admin dashboard at `/admin`.
 */
export default function Landing() {
  return (
    <main className="min-h-screen bg-brand-ink text-slate-100 font-sans">
      <Hero />
      <Features />
      <Screenshots />
      <Footer />
    </main>
  );
}
